import { studioApiUrl } from '@/environment';
import { authenticatedAxios } from '@/services/auth';

// POLOTNO MEDIA
interface GetMediaResponse {
    duration_ms?: number;
    created_at: string;
    height: number;
    width: number;
    created_by: string;
    file_name: string;
    size_bytes: number;
    id: string;
    mime_type: string;
    owner_id: string;
    modified_at: string;
    source_url: string;
    thumbnail_url?: string;
    thumbnail_ready: boolean;
}

export const getMedia = async () => {
    const response = await authenticatedAxios.get<GetMediaResponse[]>(`${studioApiUrl}/create/medias`);
    return response.data;
};

export const uploadMedia = async ({ src, metadata }: { src: string; metadata: Record<string, string> }) => {
    const response = await authenticatedAxios.post(`${studioApiUrl}/create/medias`, { source_url: src, ...metadata });
    return response.data;
};

export const deleteMedia = (mediaId: string) => {
    return authenticatedAxios.delete(`${studioApiUrl}/create/medias/${mediaId}`);
};
